/**
 * --------------------------------------------------------------------------
 * Basic Modules: BackToTop.js
 * --------------------------------------------------------------------------
 */

import Util from "./util";

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const DEBUG             = false;
const NAME              = 'backToTop';
const DATA_KEY          = NAME;
const EVENT_KEY         = `.${DATA_KEY}`;
const LOG_KEY           = `[${NAME}]`;

const Default = {
    scrollSpeed         : 800,
    scrollAnimation     : 'easeOutCubic',
    scrollPosition      : 500,
    scrollPollInterval  : 250,
    scrollThreshold     : 5,
};

const Event = {
    RESIZE              : `resize${EVENT_KEY} orientationchange${EVENT_KEY}`,
    SCROLL              : `scroll${EVENT_KEY}`,
    CLICK               : `click${EVENT_KEY}`,
};

const ClassName = {
    ACTIVE              : 'active',
};

const Selector = {
    TOGGLE              : '.js-back-to-top',
};

const DataAttr = {
};

class BackToTop {

    constructor(element, config) {

        DEBUG && console.log(LOG_KEY, 'Init');

        this.scrollInitialized = false;

        this._element = element;
        this._config  = this._getConfig(config);

        this._addEventListeners();
    }

    destroy() {
        $(this._element).off(EVENT_KEY);
        $.removeData(this._element, DATA_KEY);
        this._element = null;
    }

    // Private

    _handleClick(e) {
        e.preventDefault();
        $('body, html').animate({ scrollTop: 0}, this._config.scrollSpeed, this._config.scrollAnimation);
    }

    _getConfig(config) {
        return {
            ...Default,
            ...config
        };
    }

    _addEventListeners() {
        $(this._element).on(Event.CLICK, (event) => this._handleClick(event));
        this._handleScroll();
    }

    _handleScroll() {

        if (this.scrollInitialized === false) {

            let didScroll = false;
            let lastScrollTop = 0;

            this.scrollInitialized = true;

            $(window).on(Event.SCROLL, () => {
                didScroll = true;
            });

            // Polling the scrolling and run hasScrolled() and reset didScroll status
            setInterval(() => {
                if (didScroll) {
                    hasScrolled(); // function where stuff gets done.
                    didScroll = false;
                }
            }, this._config.scrollPollInterval);

            const hasScrolled = () => {
                let scrollTop = $(window).scrollTop();
                let distance  = Math.abs(scrollTop - lastScrollTop);

                if (distance <= this._config.scrollThreshold) { // delta
                    // Don't do anything when scrolling doesn't exceed scrolling threshold
                    return;
                }

                // Do stuff here:
                if (scrollTop > this._config.scrollPosition) {
                    $(this._element).removeClass('c:back-to-top--down').addClass('c:back-to-top--up');
                }
                else if (scrollTop < this._config.scrollPosition) {
                    $(this._element).removeClass('c:back-to-top--up').addClass('c:back-to-top--down');
                }
                // End stuff here

                lastScrollTop = scrollTop;
            }
        }
    }

    // Static

    /**
     * Convenient static method to initiate the module.
     *
     * @param config
     * @param selector
     */
    static bind (config, selector) {
        BackToTop._jQueryInterface.call($(selector || Selector.TOGGLE), config);
    }

    /**
     * jQuery Interface
     * @param config
     * @returns {*}
     */
    static _jQueryInterface(config) {
        return this.each(function() {
            const $this = $(this);
            let data    = $this.data(DATA_KEY);
            let _config = {
                ...Default,
                ...$this.data(),
                ...typeof config === 'object' && config ? config : {}
            };

            if (!data) {
                data = new BackToTop(this, _config);
                $this.data(DATA_KEY, data);
            }

            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') {
                    throw new TypeError(`No method named "${config}"`);
                }
                data[config]();
            }
        });
    }
}

/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 */

$.fn[NAME] = BackToTop._jQueryInterface;
$.fn[NAME].Constructor = BackToTop;


export default BackToTop;
